<template>
  <form :action="loginUrl" method="post" class="d-grid">
    <authenticity-token-field />
    <button type="submit" class="btn btn-light">
      <img src="../images/icons/google-sign-in.svg">
      <span>{{ i18n.t('users.shared.google_login.sign_in_with_google') }}</span>
    </button>
  </form>
</template>

<script>
import AuthenticityTokenField from '../components/inputs/authenticity-token-field'

export default {
  components: { AuthenticityTokenField },

  props: {
    loginUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  text-transform: none;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
}

img {
  height: 20px;
  padding-right: 16px;
  margin-top: -2px; // center icon with text
}
</style>
